import { ExcelGridConfig } from 'src/utils/excel/excelGridConfig';
import { MST1020_R01_BomDto, MST1020_R01HeaderDto } from './Dto_MST1020_R01';

export const MST1020_R01_EXCEL_HEADER_NAMES: Record<string, string> = {
	rowIndex: '',
	prntItemcd: '모품목코드',
	prntItemnm: '모품목명',
	childItemcd: '자품목코드',
	childItemnm: '자품목명',
	itemSpec: '규격',
	locationNm: '보관위치',
	bomSeq: '순서',
	bomUseyn: '사용여부',
	prntItemQty: '모품목수량',
	prntItemUnit: '모품목단위',
	childItemUsage: '소요량',
	childItemUnit: '자품목단위',
	fixLossqty: '고정손실량',
	materialIntype: '자재공급방법',
	lossPercent: '손실율(%)',
	applyBeginDt: '적용시작일',
	applyEndDt: '적용종료일',
	remark: '비고',
};

export const MST1020_R01_EXCEL_COLUMN_ORDER = [
	'prntItemcd', 'prntItemnm', 'childItemcd', 'childItemnm', 'itemSpec',
	'locationNm',
	'bomSeq', 'bomUseyn', 'applyBeginDt', 'applyEndDt',
	'prntItemQty', 'prntItemUnit', 'childItemUsage', 'childItemUnit', 'materialIntype',
	'fixLossqty', 'lossPercent', 'remark',
];

export const createMST1020ExcelConfig = (
	selectedItem: MST1020_R01HeaderDto | null,
	defaultRow: MST1020_R01_BomDto
): ExcelGridConfig<MST1020_R01_BomDto> => ({
	headerNames: MST1020_R01_EXCEL_HEADER_NAMES,
	columnOrder: MST1020_R01_EXCEL_COLUMN_ORDER,
	defaultRow,
	template: {
		sheetName: 'BOM 템플릿',
		fileNamePrefix: 'BOM_업로드_템플릿',
		colWidths: [12, 18, 12, 18, 15, 12, 8, 8, 12, 12, 10, 14, 10, 14, 15, 10, 10, 20],
	},
	requiredHeaders: ['자품목코드'],
	validateBeforeUpload: () => (!selectedItem ? '모품목을 먼저 선택해주세요.' : null),
	valueTransformers: {
		lossPercent: (value) => (
			typeof value === 'string' ? parseFloat(value.replace('%', '')) || 0 : value
		),
	},
	createRowMeta: (_row, _index, valueIndex) => ({
		valueIndex,
		inserted: true,
		isModified: true,
		prntItemcd: selectedItem!.itemCd,
		prntItemnm: selectedItem!.itemNm,
	}),
});
